import {
  regCapital,
  estiblishTime,
  cateList,
  companyType,
  capitalType,
  orgType,
  staffSize,
  orgDesc,
  regStatusNew,
  highFilter,
  // zyztDeac,
  khsbDesc,
  rzxxDesc,
  ssztDesc,
  searchSort,
} from '../../config/filter';
import { filterFlag, filterType } from '../../type';
import { getEstiblishTimeByVal } from '../../utils/filter';

const {
  contactType,
  // hasMobile,
  emptyPhoneFilter,
  hasEmail,
  hasTm,
  hasPatent,
  hasFinancing,
  hasBondType,
  isTaxLevel,
  isTaxpayer,
  hasBid,
  hasDishonest,
  website,
  hasMortgage,
  top500,
  hasWorkCopr,
  hasCopyright,
  isHighTechCompany,
} = highFilter;

export const cityListConfig = [
  {
    filterTitle: '省份地区',
    filterData: [],
    paramsKey: 'base',
    // filterValFun: getCapitalByVal,
    flagStr: filterFlag.AREA,
    isVip: false,
    isOption: true,
    type: filterType.SIGNAL,
    childflagStr: filterFlag.CITY,
    childParamsKey: 'city',
    childStr: 'city',
    titleStr: 'name',
    valStr: 'base',
  },
  {
    filterTitle: '城市',
    filterData: [],
    paramsKey: 'city',
    // filterValFun: getCapitalByVal,
    flagStr: filterFlag.CITY,
    isVip: false,
    isOption: true,
    type: filterType.SIGNAL,
    childflagStr: filterFlag.DISTRICT,
    childParamsKey: 'customAreaCode',
    childStr: 'district',
    titleStr: 'name',
    valStr: 'base',
  },
  {
    filterTitle: '区县',
    filterData: [],
    paramsKey: 'customAreaCode',
    // filterValFun: getCapitalByVal,
    flagStr: filterFlag.DISTRICT,
    isVip: false,
    isOption: true,
    type: filterType.SIGNAL,
    titleStr: 'name',
    valStr: 'areaCode',
  },
];

export const defaultConfig = [
  {
    filterTitle: '注册资本',
    filterData: regCapital,
    paramsKey: 'money',
    // filterValFun: getCapitalByVal,
    flagStr: filterFlag.REG_CAPITIAL,
    isVip: false,
    isOption: true,
    type: filterType.SIGNAL,
  },
  {
    filterTitle: '成立时间',
    filterData: estiblishTime,
    filterValFun: getEstiblishTimeByVal,
    paramsKey: 'estiblishTime',
    flagStr: filterFlag.ESTIBLISH_TIME,
    isVip: false,
    type: filterType.SIGNAL,
  },
  // 传参为val 行业分类、行业大类
  {
    filterTitle: '行业分类',
    filterData: cateList,
    flagStr: filterFlag.CATE,
    paramsKey: 'categoryGuobiao2017',
    titleStr: 'primInduName',
    valStr: 'primInduCode',
    isVip: false,
    type: filterType.SIGNAL,
    childflagStr: filterFlag.SEC_INDU,
    childParamsKey: 'secInduCode',
    childStr: 'secList',
  },
  {
    filterTitle: '行业大类',
    filterData: [],
    flagStr: filterFlag.SEC_INDU,
    paramsKey: 'secInduCode',
    isVip: false,
    type: filterType.SIGNAL,
    childflagStr: filterFlag.TER_INDU,
    titleStr: 'secnduName',
    valStr: 'secInduCode',
    childStr: 'terList',
    childParamsKey: 'terInduCode',
  },
  {
    filterTitle: '行业',
    filterData: [],
    flagStr: filterFlag.TER_INDU,
    paramsKey: 'terInduCode',
    isVip: false,
    type: filterType.SIGNAL,
    titleStr: 'terInduName',
    valStr: 'terInduCode',
  },
  //
  {
    filterTitle: '企业描述',
    isVip: false,
    children: [
      {
        filterTitle: '机构类型',
        filterData: companyType,
        flagStr: filterFlag.COMPANY_TYPE,
        isQuery: true, // 是否在
        paramsKey: 'companyType',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '资本类型',
        filterData: capitalType,
        flagStr: filterFlag.CAPITAL_TYPE,
        paramsKey: 'isrmb',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '企业类型',
        filterData: orgType,
        flagStr: filterFlag.ORG_TYPE,
        paramsKey: 'orgType',
        value: 'title',
        showDescription: orgDesc,
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '参保人数',
        filterData: staffSize,
        flagStr: filterFlag.STAFF_SIZE,
        paramsKey: 'staff',
        value: ['start', 'end'],
        type: filterType.DROPDOWN,
      },
    ],
  },
  {
    filterTitle: 'VIP 筛选',
    isVip: true,
    children: [
      {
        filterTitle: '联系方式',
        filterData: contactType,
        flagStr: filterFlag.CONTACT_TYPE,
        paramsKey: 'contactType',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      // {
      //   filterTitle: '手机号码',
      //   filterData: hasMobile,
      //   flagStr: filterFlag.HAS_PHONE,
      //   paramsKey: 'hasPhone',
      //   value: 'val',
      //   type: filterType.DROPDOWN,
      // },
      {
        filterTitle: '空号识别',
        filterData: emptyPhoneFilter,
        flagStr: filterFlag.EMPTY_PHONE,
        paramsKey: 'emptyPhoneFilter',
        type: filterType.DROPDOWN,
        showDescription: khsbDesc,
      },
      {
        filterTitle: '联系邮箱',
        filterData: hasEmail,
        flagStr: filterFlag.HAS_EMAIL,
        paramsKey: 'hasEmail',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '商标信息',
        filterData: hasTm,
        flagStr: filterFlag.HAS_TM,
        paramsKey: 'hasTm',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '专利信息',
        filterData: hasPatent,
        flagStr: filterFlag.HAS_PATENT,
        paramsKey: 'hasPatent',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '融资信息',
        filterData: hasFinancing,
        flagStr: filterFlag.HAS_FINANCING,
        paramsKey: 'financingRound',
        value: 'val',
        type: filterType.DROPDOWN,
        showDescription: rzxxDesc,
      },
      {
        filterTitle: '上市状态',
        filterData: hasBondType,
        flagStr: filterFlag.HAS_BOND_TYPE,
        paramsKey: 'listedType',
        value: 'val',
        type: filterType.DROPDOWN,
        showDescription: ssztDesc,
      },
      {
        filterTitle: '税务评级',
        filterData: isTaxLevel,
        flagStr: filterFlag.IS_TAX_LEVEL,
        paramsKey: 'taxLevel',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '一般纳税人',
        filterData: isTaxpayer,
        flagStr: filterFlag.IS_TAX_PAYER,
        paramsKey: 'isGeneralTaxpayer',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '招投标',
        filterData: hasBid,
        flagStr: filterFlag.HAS_BID,
        paramsKey: 'hasBid',
        value: 'val',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '失信信息',
        filterData: hasDishonest,
        flagStr: filterFlag.HAS_DISHONEST,
        paramsKey: 'hasDishonest',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '网址信息',
        filterData: website,
        flagStr: filterFlag.WEBSITE,
        paramsKey: 'hasWebsite',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '动产抵押',
        filterData: hasMortgage,
        flagStr: filterFlag.HAS_MORTGAGE,
        paramsKey: 'hasMortgage',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '500强',
        filterData: top500,
        flagStr: filterFlag.TOP500,
        paramsKey: 'top500',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '作品著作权',
        filterData: hasWorkCopr,
        flagStr: filterFlag.HAS_WORK_COPR,
        paramsKey: 'hasWorkCopr',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '软件著作权',
        filterData: hasCopyright,
        flagStr: filterFlag.HAS_COPY_RIGHT,
        paramsKey: 'hasCopyright',
        type: filterType.DROPDOWN,
      },
      {
        filterTitle: '高新技术企业',
        filterData: isHighTechCompany,
        flagStr: filterFlag.IS_HIGH_TECH_COMPANY,
        paramsKey: 'isHighTechCompany',
        type: filterType.DROPDOWN,
      },
    ],
  },
  {
    filterTitle: '企业状态',
    isVip: true,
    filterData: regStatusNew,
    flagStr: filterFlag.REG_STATUS,
    paramsKey: 'regStatusNew',
    type: filterType.SIGNAL,
    // showDescription: zyztDeac, // 去除企业状态筛选说明
  },
];

export const sortTypeConfig = {
  filterTitle: '排序方式',
  filterData: searchSort,
  paramsKey: 'sortType',
  flagStr: filterFlag.LIST_SORT,
  isVip: false,
  type: filterType.SIGNAL,
  valStr: 'value',
  titleStr: 'label',
};
